import Cookies from 'js-cookie';
import addCookieWithConsent from '../../utilities/addCookieWithConsent';
import forceLogoutHandler from './a.users.forceLogoutHandler';

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// EditUserProfile
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestEditUserProfile = packet => {
  return {
    type: 'REQUEST_EDIT_USER_PROFILE',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveEditUserProfileSuccess = data => ({
  type: 'RECEIVE_EDIT_USER_PROFILE_SUCCESS',
  data
})

export const receiveEditUserProfileFail = data => ({
  type: 'RECEIVE_EDIT_USER_PROFILE_FAIL',
  data
})

export const tryToEditUserProfile = packet => (dispatch, getState) => {

  dispatch(requestEditUserProfile(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;

  return fetch('/api/users/profile', {
      method: 'put',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveEditUserProfileSuccess(json.data));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveEditUserProfileFail({errors:e, lastSubmit: packet}));
    })
}
